import { render, staticRenderFns } from "./BankItem.vue?vue&type=template&id=ae09c0ee&scoped=true&"
import script from "./BankItem.vue?vue&type=script&lang=js&"
export * from "./BankItem.vue?vue&type=script&lang=js&"
import style0 from "./BankItem.vue?vue&type=style&index=0&id=ae09c0ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae09c0ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae09c0ee')) {
      api.createRecord('ae09c0ee', component.options)
    } else {
      api.reload('ae09c0ee', component.options)
    }
    module.hot.accept("./BankItem.vue?vue&type=template&id=ae09c0ee&scoped=true&", function () {
      api.rerender('ae09c0ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/profile/components/BankItem.vue"
export default component.exports